import { useEffect, useState } from "react";
import { Loader2, Plus, X } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";

export default function SiteSettings() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings/site").then((r) => setForm({ stats: [], hubs: [], ...r.data }));
  }, []);

  if (!form) return <p className="text-zinc-600">Loading…</p>;

  const set = (key) => (e) => setForm({ ...form, [key]: e?.target ? e.target.value : e });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/admin/settings/site", form);
      toast.success("Homepage settings saved");
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setSaving(false);
    }
  };

  const TEXT = [
    ["hero_kicker", "Hero kicker"],
    ["hero_title", "Hero headline"],
    ["hero_subtitle", "Hero subtitle"],
    ["intro_title", "Intro heading"],
    ["intro_attribution", "Intro attribution"],
    ["plans_statement", "Journey statement"],
    ["contact_email", "Contact email"],
  ];

  return (
    <form onSubmit={save} data-testid="admin-settings-page">
      <p className="overline">Homepage</p>
      <h1 className="display-2 mt-4">Site settings</h1>

      <div className="mt-10 grid gap-5 border border-zinc-900 bg-ink-surface p-6 md:grid-cols-2 md:p-8">
        {TEXT.map(([key, label]) => (
          <div key={key}>
            <label className="overline">{label}</label>
            <input className="field mt-2" value={form[key] || ""} onChange={set(key)} data-testid={`settings-${key}`} />
          </div>
        ))}
        <div className="md:col-span-2">
          <label className="overline">Intro body</label>
          <textarea rows={4} className="field mt-2" value={form.intro_body || ""} onChange={set("intro_body")} data-testid="settings-intro_body" />
        </div>
        <div className="md:col-span-2">
          <p className="overline">Rotating stats</p>
          <div className="mt-3 space-y-3" data-testid="settings-stats">
            {(form.stats || []).map((s, i) => (
              <div key={i} className="flex gap-2">
                <input className="field w-28" placeholder="Value" value={s.value || ""} onChange={(e) => setForm({ ...form, stats: form.stats.map((r, j) => (j === i ? { ...r, value: e.target.value } : r)) })} />
                <input className="field flex-1" placeholder="Label" value={s.label || ""} onChange={(e) => setForm({ ...form, stats: form.stats.map((r, j) => (j === i ? { ...r, label: e.target.value } : r)) })} />
                <button type="button" aria-label="Remove stat" onClick={() => setForm({ ...form, stats: form.stats.filter((_, j) => j !== i) })} className="border border-zinc-800 px-3 text-zinc-500 hover:text-kenya-red">
                  <X size={14} />
                </button>
              </div>
            ))}
            <button type="button" onClick={() => setForm({ ...form, stats: [...(form.stats || []), { value: "", label: "" }] })} className="btn-ghost !px-5 !py-2.5" data-testid="settings-add-stat">
              <Plus size={13} /> Add stat
            </button>
          </div>
        </div>
      </div>

      <button type="submit" disabled={saving} className="btn-primary mt-8 disabled:opacity-60" data-testid="settings-save">
        {saving ? <Loader2 className="animate-spin" size={14} /> : null} Save settings
      </button>
    </form>
  );
}
